import { trim } from 'lodash';
import moment from 'moment';
import cookies from 'js-cookie';
import { List } from 'immutable';
import { getItem } from '~helpers/storage';
import { cookieNames } from '~client/constants';
import { getLocale } from '~helpers/locale';

export const generateSlug = name =>
  name
    .match(/[a-zA-Z]|[0-9]|\s/g)
    .reduce((result, item) => result + item)
    .replace(/\s/g, '-')
    .toLowerCase();

export const cloneObject = obj => JSON.parse(JSON.stringify(obj));

export const htmlToString = element => {
  if (!element || !element.tagName) {
    return '';
  }
  let text;
  let node = document.createElement('div');
  node.appendChild(element.cloneNode(false));
  text = node.innerHTML;
  const string = text.indexOf('>') + 1;
  text = text.substring(0, string) + element.innerHTML + text.substring(string);
  node = null;
  return text;
};

export const renameObjectKey = (object, oldKey, newKey) => {
  if (oldKey !== newKey && Object.prototype.hasOwnProperty.call(object, oldKey)) {
    Object.defineProperty(object, newKey, Object.getOwnPropertyDescriptor(object, oldKey));
    delete object[oldKey]; // eslint-disable-line no-param-reassign
  }
  return object;
};

export const mergeWithoutList = (a, b) => {
  const isList = List.isList;
  if (a && a.mergeWith && !isList(a) && !isList(b)) {
    return a.mergeWith(mergeWithoutList, b);
  }
  return b;
};

export const getHeader = () => {
  const authorization = `Bearer ${cookies.get(cookieNames.token)}`;
  const headers = {
    Authorization: authorization,
    'Accept-Language': 'en-us',
  };
  const authPayload = getItem('PMS_CURRENT_USER_AUTH');

  if (authPayload && authPayload.payload && authPayload.payload.currentRoleSlug) {
    headers['Current-Role'] = authPayload.payload.currentRoleSlug;
  }

  return headers;
};

export const camelCaseToUpperFirstCase = string => {
  if (typeof string === 'string') {
    // Add ' ' to upper charater
    const newString = string.replace(/([a-z])([A-Z])/g, '$1 $2');
    return newString.charAt(0).toUpperCase() + newString.slice(1);
  }
  return string;
};

export const showPassportName = student => {
  if (!student) return null;
  const { passportFirstName, passportLastName, passportMiddleName, firstName, lastName } = student;
  if (passportFirstName || passportLastName || passportMiddleName) {
    return trim(`${passportFirstName || ''} ${passportMiddleName || ''} ${passportLastName || ''}`);
  }

  return trim(`${firstName || ''} ${lastName || ''}`);
};

export const chooseMomentLocale = () => {
  const locale = getLocale().replace('_', '-');
  if (moment.locales().includes(locale)) {
    return locale;
  } else if (moment.locales().includes(locale.substring(0, locale.indexOf('-')))) {
    // check if the first two letters of the locale
    // are included in the array returned by `locales()`
    // which (in this case) tells us which locales moment will support
    // will fixes crashes caused by "en-US" not being found,
    // as we'll tell moment to load "en" instead
    return locale.substring(0, locale.indexOf('-'));
  }
  return 'en';
};

export const formatFullTime = time => {
  const momentTime = moment(time).locale(chooseMomentLocale());
  return `${momentTime.format('LL')} ${momentTime.format('H:mm:ss')}`;
};

export const formatSimpleParams = (defaultParams, data, excludeParams = []) => {
  const formatted = {};
  Object.keys(defaultParams).forEach(item => {
    if (excludeParams.indexOf(item) !== -1) {
      formatted[item] = data[item] || defaultParams[item];
    } else if (
      typeof data[item] === 'undefined' ||
      data[item] === null ||
      (data[item] && data[item].length === 0)
    ) {
      // Handle if item is empty
      if (defaultParams[item] !== null) {
        formatted[item] = defaultParams[item];
      }
    } else {
      formatted[item] = data[item];
    }
  });

  return formatted;
};
